// extracted by mini-css-extract-plugin
export default {"keyboard_wrapper":"Keyboard_keyboard_wrapper__JQJgm","keyboard_keys":"Keyboard_keyboard_keys__ix7DC","action_buttons":"Keyboard_action_buttons__J3q5J"};